import {
  IUsePersonalAccountJWTProps,
  usePersonalAccountJWT,
} from './usePersonalAccountJWT';
import { usePersonalAccountState } from './usePersonalAccountState';

export interface UseInitPersonalAccountProps
  extends IUsePersonalAccountJWTProps {}

export const useInitPersonalAccount = ({
  skipFetching,
}: UseInitPersonalAccountProps = {}) => {
  const { isInitialized } = usePersonalAccountState();

  usePersonalAccountJWT({
    skipFetching: skipFetching || isInitialized,
  });
};
